/**
 * Krudo in-place image zoom.
 *
 * Intercepts clicks on `a.product__gallery-toggle[data-pswp-src]` and, instead
 * of opening a lightbox or following the link, zooms the image inside its own
 * gallery container. The focal point (transform-origin) follows the cursor
 * while zoomed in, giving a magnifying-glass-style pan. Click again to reset.
 *
 * Coexists with PhotoSwipe: if PhotoSwipe has already called preventDefault on
 * the same click, this handler bails out (`if (e.defaultPrevented) return`).
 */
(function () {
  if (window.__krudoImageZoomInit) return;
  window.__krudoImageZoomInit = true;

  const ZOOM_LEVEL = 2.5;
  const ZOOMED_CLASS = 'is-krudo-zoomed';

  function findImg(link) {
    return link.querySelector('img');
  }

  function pointerCoords(e) {
    if (e.touches && e.touches.length) {
      return { clientX: e.touches[0].clientX, clientY: e.touches[0].clientY };
    }
    if (e.changedTouches && e.changedTouches.length) {
      return { clientX: e.changedTouches[0].clientX, clientY: e.changedTouches[0].clientY };
    }
    return { clientX: e.clientX, clientY: e.clientY };
  }

  function focalFromEvent(img, e) {
    const rect = img.getBoundingClientRect();
    const p = pointerCoords(e);
    const x = Math.max(0, Math.min(100, ((p.clientX - rect.left) / rect.width) * 100));
    const y = Math.max(0, Math.min(100, ((p.clientY - rect.top) / rect.height) * 100));
    return { x: x, y: y };
  }

  function zoomIn(img, e) {
    const focal = focalFromEvent(img, e);
    img.style.transformOrigin = focal.x + '% ' + focal.y + '%';
    img.style.transform = 'scale(' + ZOOM_LEVEL + ')';
    img.style.cursor = 'zoom-out';
    img.classList.add(ZOOMED_CLASS);

    const container = img.closest('.media, .product-media, .product__gallery-toggle');
    if (container) {
      container.dataset.krudoZoomPrevOverflow = container.style.overflow || '';
      container.style.overflow = 'hidden';
    }

    img.addEventListener('mousemove', onPointerMove);
    img.addEventListener('mouseleave', onPointerLeave);
    img.addEventListener('touchmove', onPointerMove, { passive: false });
    img.addEventListener('touchend', onPointerLeave);
    img.addEventListener('touchcancel', onPointerLeave);
  }

  function zoomOut(img) {
    img.style.transformOrigin = '';
    img.style.transform = '';
    img.style.cursor = 'zoom-in';
    img.classList.remove(ZOOMED_CLASS);

    const container = img.closest('.media, .product-media, .product__gallery-toggle');
    if (container) {
      container.style.overflow = container.dataset.krudoZoomPrevOverflow || '';
      delete container.dataset.krudoZoomPrevOverflow;
    }

    img.removeEventListener('mousemove', onPointerMove);
    img.removeEventListener('mouseleave', onPointerLeave);
    img.removeEventListener('touchmove', onPointerMove);
    img.removeEventListener('touchend', onPointerLeave);
    img.removeEventListener('touchcancel', onPointerLeave);
  }

  function onPointerMove(e) {
    const img = e.currentTarget;
    if (!img.classList.contains(ZOOMED_CLASS)) return;
    // Prevent page scroll while panning the zoomed image on touch.
    if (e.cancelable && e.touches) e.preventDefault();
    const focal = focalFromEvent(img, e);
    img.style.transformOrigin = focal.x + '% ' + focal.y + '%';
  }

  function onPointerLeave(e) {
    const img = e.currentTarget;
    if (!img.classList.contains(ZOOMED_CLASS)) return;
    img.style.transformOrigin = '50% 50%';
  }

  function handle(e) {
    const link = e.target.closest('a.product__gallery-toggle[data-pswp-src]');
    if (!link) return;
    // Run before PhotoSwipe (capture phase) and prevent it from also firing.
    e.preventDefault();
    e.stopImmediatePropagation();
    const img = findImg(link);
    if (!img) return;
    if (img.classList.contains(ZOOMED_CLASS)) {
      zoomOut(img);
    } else {
      zoomIn(img, e);
    }
  }

  document.addEventListener('click', handle, true);
})();
